export default __webpack_public_path__ + "static/media/2-min.efa8d6c0.jpg";